import { InvoicesStatus, QuotesStatus } from '__generated__/GQL';

type InvoicesOrQuotesStatus = Omit<
  Partial<InvoicesStatus> | Partial<QuotesStatus>,
  '__typename'
>;

export const getTotalCountOf = (
  invoicesOrQuotesStatus: InvoicesOrQuotesStatus,
) => {
  return Object.values(invoicesOrQuotesStatus).reduce((acc, curr) => {
    if (curr?.count) {
      return acc + curr.count;
    }
    return acc;
  }, 0);
};
